<template>
  <div class="container-fluid py-4">
    <div class="row">
      <!-- 첫 번째 카드 (학생 목록) -->
      <div class="col-md-4 mb-10">
        <div class="card">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div
              class="bg-gradient-success shadow-success searchInput border-radius-lg pt-4 pb-3 d-flex align-items-center justify-content-between px-3 filters-bar flex-wrap"
            >
              <!-- 제목 -->
              <!-- 필터 -->
              <select
                v-model="filters.department"
                @change="fetchGrades()"
                class="form-select searchInput me-1"
                style="width: fit-content; padding-left: 5px; padding-right: 10px; border: 1px solid #ced4da; text-align: center; background-color: white !important;"
              >
                <option value="">부서 선택</option>
                <option v-for="department in departments" :key="department.id" :value="department.id">
                  {{ department.name }}
                </option>
              </select>
              <select
                v-model="filters.grade"
                @change="fetchStudents(1)"
                class="form-select searchInput"
                style="width: fit-content; padding-left: 5px; padding-right: 15px; border: 1px solid #ced4da; text-align: center; background-color: white !important;"
              >
                <option value="">반 선택</option>
                <option value="all">전체</option>
                <option v-for="group in grades" :key="group.id" :value="group.id">
                  {{ group.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th>
                      <div class="d-flex justify-content-between align-items-center search-tools flex-wrap">
                        <div class="d-flex align-items-center search-tools flex-wrap">
                          <input
                            v-model="filters.name"
                            @keyup.enter="fetchStudents(1)"
                            type="text"
                            class="form-control form-control-sm search-name me-2"
                            placeholder="이름 검색"
                          />
                          <button class="btn btn-success btn-sm me-2" @click="fetchStudents(1)">검색</button>
                          <div class="form-check form-check-inline d-flex align-items-center">
                            <input
                              class="form-check-input me-1"
                              type="checkbox"
                              id="chk-include-deleted"
                              :checked="filters.withdrawal === 'include'"
                              @change="toggleIncludeDeleted"
                            />
                            <label class="form-check-label" for="chk-include-deleted" style="user-select: none;">삭제포함</label>
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="students.length === 0">
                    <td class="text-center">조회된 자료가 없습니다</td>
                  </tr>
                  <tr v-for="student in students" :key="student.no">
                    <div class="border-bottom" @click="selectStudent(student)" @mouseover="student.hover = true" @mouseleave="student.hover = false" :style="{ 'background-color': student.hover ? '#e9ecef' : 'white' }">
                    <td>
                      <div class="d-flex px-2 py-1" >
                        <div>
                          <img
                        :src="student.photo !== null && student.photo !== ''
                                ? `https://manna.dongan1718.com/upload/photo/${student.photo}` 
                                : student.photo2 !== null && student.photo2 !== ''
                                ? `https://manna.dongan1718.com/upload/photo/${student.photo2}` 
                                : require('@/assets/img/noimage.png')"
                        class="avatar me-3 border-radius-lg"
                        alt="photo"
                      />
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ student.name }}</h6>
                          <p class="text-xs text-secondary mb-0">{{ student.email }}</p>
                        </div>
                      </div>
                    </td>
                  </div>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- 페이지네이션 추가 -->
            <div class="d-flex justify-content-center mt-4">
              <div class="text-center mb-2" v-if="totalRows > 0">
                <small class="text-muted">총 {{ totalRows }}개</small>
              </div>
              <nav aria-label="Page navigation" v-if="totalPages > 0">
                <ul class="pagination">
                  <li class="page-item" :class="{ disabled: currentPage === 1 }">
                    <a class="page-link" href="#" @click.prevent="currentPage > 1 && fetchStudents(currentPage - 1)">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li v-for="page in displayedPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                    <a class="page-link" href="#" @click.prevent="fetchStudents(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                    <a class="page-link" href="#" @click.prevent="currentPage < totalPages && fetchStudents(currentPage + 1)">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <!-- 오른쪽 상세 레이아웃 -->
      <div class="col-md-8 mb-4" v-if="selectedStudent">
        <div class="card">
          <div class="card-header p-3">
            <h5>학생(아동) 기본 정보</h5>
          </div>
          <div class="card-body detail-compact">
            <div class="row align-items-start">
              <div class="col-md-4">
                <h6>사진</h6>
                <img
                  :src="selectedStudent.photo !== null && selectedStudent.photo !== ''
                    ? `https://manna.dongan1718.com/upload/photo/${selectedStudent.photo}` 
                    : selectedStudent.photo2 !== null && selectedStudent.photo2 !== ''
                    ? `https://manna.dongan1718.com/upload/photo/${selectedStudent.photo2}` 
                    : require('@/assets/img/noimage.png')"
                  class="profile-photo border-radius-lg"
                  alt="photo"
                />
              </div>
              <div class="col-md-8">
                <div class="row info-grid">
                  <div class="col-md-4">
                    <h6>이름</h6>
                    <p style="font-size: 1.1rem; font-weight: bold; color: blue;">{{ selectedStudent.name }}</p>
                  </div>
                  <div class="col-md-4">
                    <h6>성별</h6>
                    <select v-if="isEditing" class="form-control" v-model="editingStudent.sex">
                      <option value="">선택</option>
                      <option value="남">남</option>
                      <option value="여">여</option>
                    </select>
                    <p v-else>{{ selectedStudent.sex }}</p>
                  </div>
                  <div class="col-md-4">
                    <h6>생년월일</h6>
                    <input v-if="isEditing" type="text" class="form-control" v-model="editingStudent.birthday" placeholder="YYYY-MM-DD">
                    <p v-else>{{ selectedStudent.birthday }}</p>
                  </div>
                  <div class="col-md-4">
                    <h6>연락처</h6>
                    <input v-if="isEditing" type="text" class="form-control" v-model="editingStudent.phone">
                    <p v-else>{{ selectedStudent.phone }}</p>
                  </div>
                  <div class="col-md-4">
                    <h6>학교</h6>
                    <input v-if="isEditing" type="text" class="form-control" v-model="editingStudent.school">
                    <p v-else>{{ selectedStudent.school }}</p>
                  </div>
                  <div class="col-md-4">
                    <h6>학부모 성함</h6>
                    <input v-if="isEditing" type="text" class="form-control" v-model="editingStudent.parentname">
                    <p v-else>{{ selectedStudent.parentname }}</p>
                  </div>
                  <div class="col-md-4">
                    <h6>학부모 연락처</h6>
                    <input v-if="isEditing" type="text" class="form-control" v-model="editingStudent.parentphone">
                    <p v-else>{{ selectedStudent.parentphone }}</p>
                  </div>
                  <div class="col-md-4">
                    <h6>부서</h6>
                    <select v-if="isEditing" class="form-control" v-model="editingStudent.classid" @change="onEditDeptChange">
                      <option v-for="d in departments" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <p v-else>{{ departments.find(d => d.id === selectedStudent.classid)?.name || '' }}</p>
                  </div>
                  <div class="col-md-4">
                    <h6>반</h6>
                    <select v-if="isEditing" class="form-control" v-model="editingStudent.grade" @change="syncEditGradename">
                      <option v-for="g in editGrades" :key="g.grade" :value="g.grade">{{ g.gradename }}</option>
                    </select>
                    <p v-else>{{ selectedStudent.gradename }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <h6>주소</h6>
                    <input v-if="isEditing" type="text" class="form-control" v-model="editingStudent.address">
                    <p v-else>{{ selectedStudent.address }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h6>참고사항</h6>
                <textarea v-if="isEditing" class="form-control" v-model="editingStudent.rmk" rows="2"></textarea>
                <p v-else class="preline">{{ selectedStudent.rmk }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-end">
                <template v-if="isEditing">
                  <button v-if="editingStudent.useyn !== 'N'" class="btn btn-outline-danger me-2" @click="deleteStudent">삭제</button>
                  <button v-else class="btn btn-outline-warning me-2" @click="restoreStudent">복구</button>
                  <button class="btn btn-secondary me-2" @click="cancelEdit">취소</button>
                  <button class="btn btn-success" @click="saveChanges">저장</button>
                </template>
                <button v-else class="btn btn-success" @click="toggleEdit">수정</button>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 15px;"></div>
        <!-- 학생정보 카드 -->
        <div class="card">
          <div class="card-header p-3">
            <h5>학생정보</h5>
          </div>
          <div class="card-body detail-compact">
            <div class="row align-items-center mb-2">
              <div class="col-md-3"><span>1. 특기, 취미</span></div>
              <div class="col-md-9">
                <input v-if="isEditingStudentInfo" type="text" class="form-control" v-model="studentExtra.hobby">
                <p v-else>{{ studentExtra.hobby }}</p>
              </div>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-md-3"><span>2. 친한친구</span></div>
              <div class="col-md-9">
                <input v-if="isEditingStudentInfo" type="text" class="form-control" v-model="studentExtra.bestfriend">
                <p v-else>{{ studentExtra.bestfriend }}</p>
              </div>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-md-3"><span>3. 주의사항</span></div>
              <div class="col-md-9">
                <input v-if="isEditingStudentInfo" type="text" class="form-control" v-model="studentExtra.caution">
                <p v-else>{{ studentExtra.caution }}</p>
              </div>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-md-3"><span>4. 예배출석</span></div>
              <div class="col-md-9">
                <input v-if="isEditingStudentInfo" type="text" class="form-control" v-model="studentExtra.worship_attendance">
                <p v-else>{{ studentExtra.worship_attendance }}</p>
              </div>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-md-3"><span>5. 분반참여도</span></div>
              <div class="col-md-9">
                <input v-if="isEditingStudentInfo" type="text" class="form-control" v-model="studentExtra.class_participation">
                <p v-else>{{ studentExtra.class_participation }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-end">
                <template v-if="isEditingStudentInfo">
                  <button class="btn btn-secondary me-2" @click="isEditingStudentInfo=false">취소</button>
                  <button class="btn btn-success" @click="saveStudentInfo">저장</button>
                </template>
                <button v-else class="btn btn-success" @click="isEditingStudentInfo=true">수정</button>
              </div>
            </div>
          </div>
        </div>

        <div style="height: 15px;"></div>

        <!-- 교사소견 카드 -->
        <div class="card">
          <div class="card-header p-3">
            <h5>교사소견</h5>
          </div>
          <div class="card-body detail-compact">
            <div class="mb-2">
              <div class="mb-1"><span>1. 가정환경</span></div>
              <textarea v-if="isEditingTeacherOpinion" class="form-control" v-model="studentExtra.home_env" rows="2"></textarea>
              <p v-else class="preline">{{ studentExtra.home_env }}</p>
            </div>
            <div class="mb-2">
              <div class="mb-1"><span>2. 학생특징</span></div>
              <textarea v-if="isEditingTeacherOpinion" class="form-control" v-model="studentExtra.student_characteristics" rows="2"></textarea>
              <p v-else class="preline">{{ studentExtra.student_characteristics }}</p>
            </div>
            <div class="mb-2">
              <div class="mb-1"><span>3. 종합적 소견</span></div>
              <textarea v-if="isEditingTeacherOpinion" class="form-control" v-model="studentExtra.overall_opinion" rows="2"></textarea>
              <p v-else class="preline">{{ studentExtra.overall_opinion }}</p>
            </div>
            <div class="row">
              <div class="col-12 text-end">
                <template v-if="isEditingTeacherOpinion">
                  <button class="btn btn-secondary me-2" @click="isEditingTeacherOpinion=false">취소</button>
                  <button class="btn btn-success" @click="saveTeacherOpinion">저장</button>
                </template>
                <button v-else class="btn btn-success" @click="isEditingTeacherOpinion=true">수정</button>
              </div>
            </div>
          </div>
        </div>

        <div style="height: 15px;"></div>
<!-- 교육(훈련)정보 -->
        <div class="card">
          <div class="card-header p-3">
            <h5>교육(훈련) 정보</h5><font color="red">( 개발 예정)</font>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h6>교육명</h6>
                <p></p>
              </div>
              <div class="col-md-6">
                <h6>세례(입교)</h6>
                <p></p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <h6>봉사참여</h6>
                <p></p>
              </div>
              <div class="col-md-6">
                <h6>기타활동</h6>
                <p></p>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <h6>기타</h6>
              </div>
            </div>
          </div>
        </div>

        <div style="height: 15px;"></div>

<!-- 출결 현황  -->
  <div class="card">
          <div class="card-header p-3">
            <h5>출결 현황</h5>
          </div>
          <div class="card-body">
         </div>
        </div>

        <div style="height: 15px;"></div>
<!-- 분반 보고서  -->
        <div class="card">
          <div class="card-header p-3">
            <h5>분반 보고서</h5>
          </div>
          <div class="card-body">
         </div>
        </div>

<!-- 분반 보고서  -->
      </div>
    </div>
  </div>
</template>

<script>
import apiservice from "../services/apiservice";

export default {
  name: "tables",
  data() {
    return {
      students: [],
      currentPage: 1,
      totalPages: 1,
      totalRows: 0,
      selectedStudent: null,
      filters: {
        department: "",
        grade: "",
        withdrawal: "exclude",
        name: "",
        useyn: "Y"
      },
      departments: [],
      grades: [],
      isEditing: false,
      editingStudent: null,
      editingStudentDefault: {
        no: null,
        classid: '',
        grade: '',
        gradename: '',
        teacherid: '',
        teachername: '',
        studentid: '',
        name: '',
        birthday: '',
        phone: '',
        school: '',
        parentname: '',
        parentphone: '',
        sex: '',
        address: '',
        rmk: '',
        useyn: 'Y',
        photo: '',
        photo2: ''
      },
      editGrades: [],
      // 부가 정보
      studentExtra: {
        hobby: '',
        bestfriend: '',
        caution: '',
        worship_attendance: '',
        class_participation: '',
        home_env: '',
        student_characteristics: '',
        overall_opinion: ''
      },
      isEditingStudentInfo: false,
      isEditingTeacherOpinion: false
    };
  },
  computed: {
    isSuperUser() {
      return this.$store.state.userData?.superuser === '1';
    },
    displayedPages() {
      const pages = [];
      const maxVisiblePages = 5;
      
      if (this.totalPages <= maxVisiblePages) {
        // 전체 페이지가 최대 표시 페이지 수보다 작거나 같으면 모든 페이지 표시
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        // 현재 페이지 주변의 페이지만 표시
        let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = startPage + maxVisiblePages - 1;
        
        if (endPage > this.totalPages) {
          endPage = this.totalPages;
          startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }
        
        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }
      
      return pages;
    }
  },
  watch: {
    'editingStudent.classid'(newVal, oldVal) {
      if (this.isEditing && newVal !== oldVal) {
        this.onEditDeptChange();
      }
    }
  },
  methods: {
    async fetchStudents(page = 1) {
      if (!this.filters.department && !this.filters.grade) {
        console.warn("부서 또는 반을 선택해주세요.");
        alert("부서 또는 반을 선택해주세요.");
        return;
      }
      
      try {
        // 페이지 번호 유효성 검사
        page = parseInt(page);
        if (isNaN(page) || page < 1) page = 1;
        
        // 필터 데이터 복사
        const filterParams = { ...this.filters };
        
        // "전체" 선택 시 grade 파라미터 처리
        if (filterParams.grade === 'all') {
          filterParams.grade = '';
          filterParams.allGrades = true;
        }
        
        console.log("Fetching students with params:", { page, ...filterParams });
        
        const response = await apiservice.memberlist({
          params: { 
            page, 
            limit: 8,
            ...filterParams 
          },
        });
        
        if (response.data && response.data.data) {
          this.students = response.data.data;
          this.currentPage = parseInt(response.data.currentPage || page);
          this.totalPages = parseInt(response.data.totalPages || 1);
          this.totalRows = parseInt(response.data.totalRows || 0);
          
          // 디버깅 정보 출력
          if (response.data.debug) {
            console.log("Backend debug info:", response.data.debug);
            console.log("Total rows:", response.data.totalRows);
          }
          
          // 페이지 번호가 유효하지 않은 경우 처리
          if (this.totalPages < 1) this.totalPages = 1;
          if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;
          
          console.log("Fetched students:", this.students.length);
          console.log("Current page:", this.currentPage, "Total pages:", this.totalPages);
          
          // 첫 번째 학생 자동 선택
          if (this.students.length > 0 && !this.selectedStudent) {
            this.selectStudent(this.students[0]);
          }
        } else {
          console.error("Unexpected response format:", response);
          this.students = [];
          this.currentPage = 1;
          this.totalPages = 1;
          this.totalRows = 0;
          this.selectedStudent = null;
        }
      } catch (error) {
        console.error("Failed to fetch students:", error);
        this.students = [];
        this.currentPage = 1;
        this.totalPages = 1;
        this.totalRows = 0;
        this.selectedStudent = null;
      }
    },  
    async fetchDepartments() {
      try {
        const response = await apiservice.getdeptlist();
        this.departments = response.data.data.map(department => ({
          id: department.code,
          name: department.codename
        }));

      } catch (error) {
        console.error("Failed to fetch departments:", error);
      }
    },
    async fetchGrades() {
      if (!this.filters.department) {
        this.grades = [];
        this.selectedStudent = null;
        return;
      }
      
      try {        
        const response = await apiservice.getclasslist({ classid: this.filters.department });
        this.grades = response.data.data.map(grade => ({
          id: grade.grade,
          name: grade.gradename
        }));
        
        // 반 목록을 가져온 후 자동으로 "전체" 선택
        this.filters.grade = "all";
        
        // 반 목록이 변경되면 학생 목록 다시 가져오기
        this.fetchStudents(1);
      } catch (error) {
        console.error("Failed to fetch grades:", error);
      }
    },
    selectStudent(student) {
      // 필요한 필드만 선택하여 복사
      this.selectedStudent = {
        no: student.no,
        classid: student.classid,
        grade: student.grade,
        gradename: student.gradename,
        teacherid: student.teacherid,
        teachername: student.teachername,
        useyn: student.useyn,
        studentid: student.studentid,
        name: student.name,
        birthday: student.birthday,
        phone: student.phone,
        school: student.school,
        parentname: student.parentname,
        parentphone: student.parentphone,
        sex: student.sex,
        address: student.address,
        rmk: student.rmk,
        photo: student.photo,
        photo2: student.photo2
      };
      this.isEditing = false;
      this.editingStudent = null;
      // 부가 정보 로드
      this.fetchMemberExtra();
    },
    async fetchMemberExtra() {
      if (!this.selectedStudent || !this.selectedStudent.studentid) return;
      try {
        const response = await apiservice.getmemberextra({ studentid: this.selectedStudent.studentid });
        if (response.data && response.data.success && response.data.data) {
          this.studentExtra = {
            hobby: response.data.data.hobby || '',
            bestfriend: response.data.data.bestfriend || '',
            caution: response.data.data.caution || '',
            worship_attendance: response.data.data.worship_attendance || '',
            class_participation: response.data.data.class_participation || '',
            home_env: response.data.data.home_env || '',
            student_characteristics: response.data.data.student_characteristics || '',
            overall_opinion: response.data.data.overall_opinion || ''
          };
        } else {
          this.studentExtra = {
            hobby: '', bestfriend: '', caution: '', worship_attendance: '', class_participation: '',
            home_env: '', student_characteristics: '', overall_opinion: ''
          };
        }
      } catch (e) {
        alert('부가 정보 조회 중 오류가 발생했습니다.');
      }
    },
    async saveStudentInfo() {
      if (!this.selectedStudent || !this.selectedStudent.studentid) return;
      try {
        const payload = { studentid: this.selectedStudent.studentid, ...this.studentExtra };
        const response = await apiservice.updatememberextra(payload);
        if (response.data && response.data.success) {
          this.isEditingStudentInfo = false;
          alert('저장되었습니다.');
        } else {
          alert('저장에 실패했습니다.');
        }
      } catch (e) {
        alert('저장 중 오류가 발생했습니다.');
      }
    },
    async saveTeacherOpinion() {
      // 동일 저장 엔드포인트
      await this.saveStudentInfo();
      this.isEditingTeacherOpinion = false;
    },
    toggleEdit() {
      this.isEditing = true;
      // 깊은 복사를 사용하여 데이터 복사
      this.editingStudent = Object.assign({}, this.editingStudentDefault, JSON.parse(JSON.stringify(this.selectedStudent)));
      console.log('Editing Student Initialized:', this.editingStudent);
      this.onEditDeptChange();
    },
    cancelEdit() {
      this.isEditing = false;
      this.editingStudent = null;
    },
    async saveChanges() {
      try {
        console.log('Editing Student Data:', this.editingStudent);
        
        // 서버에 전송할 데이터 준비
        const updateData = {
          no: this.editingStudent.no,
          classid: this.editingStudent.classid,
          grade: this.editingStudent.grade,
          gradename: this.editingStudent.gradename,
          teacherid: this.editingStudent.teacherid || '',
          teachername: this.editingStudent.teachername || '',
          birthday: this.editingStudent.birthday,
          phone: this.editingStudent.phone,
          school: this.editingStudent.school,
          parentname: this.editingStudent.parentname,
          parentphone: this.editingStudent.parentphone,
          sex: this.editingStudent.sex,
          address: this.editingStudent.address,
          rmk: this.editingStudent.rmk
        };

        console.log('Update Data:', updateData);

        // 서버에 수정된 정보 전송
        const response = await apiservice.updatemember(updateData);
        
        console.log('Server Response:', response);

        if (response.data.success) {
          // 성공적으로 저장된 경우
          this.selectedStudent = { ...this.editingStudent };
          this.isEditing = false;
          alert('저장되었습니다.');
          
          // 학생 목록 새로고침
          this.fetchStudents(this.currentPage);
        } else {
          console.error('Server returned error:', response.data);
          alert(response.data.message || '저장 중 오류가 발생했습니다.');
        }
      } catch (error) {
        console.error('Failed to save changes:', error);
        console.error('Error details:', {
          name: error.name,
          message: error.message,
          stack: error.stack
        });
        alert('저장 중 오류가 발생했습니다.');
      }
    },
    async deleteStudent() {
      if (!this.editingStudent || !this.editingStudent.no) return;
      if (!confirm('정말 삭제하시겠습니까? (useyn = N)')) return;
      try {
        const resp = await apiservice.updatemember({
          no: this.editingStudent.no,
          useyn: 'N'
        });
        if (resp.data && resp.data.success) {
          alert('삭제되었습니다.');
          this.isEditing = false;
          if (this.editingStudent) this.editingStudent.useyn = 'N';
          if (this.selectedStudent) this.selectedStudent.useyn = 'N';
          // 활성만 보는 필터일 때 목록에서 제외되도록 재조회
          this.fetchStudents(1);
        } else {
          alert('삭제에 실패했습니다.');
        }
      } catch (e) {
        console.error('Delete error:', e);
        alert('삭제 중 오류가 발생했습니다.');
      }
    },
    async restoreStudent() {
      if (!this.editingStudent || !this.editingStudent.no) return;
      if (!confirm('이 학생을 복구하시겠습니까? (useyn = Y)')) return;
      try {
        const resp = await apiservice.updatemember({
          no: this.editingStudent.no,
          useyn: 'Y'
        });
        if (resp.data && resp.data.success) {
          alert('복구되었습니다.');
          this.isEditing = false;
          if (this.editingStudent) this.editingStudent.useyn = 'Y';
          if (this.selectedStudent) this.selectedStudent.useyn = 'Y';
          this.fetchStudents(1);
        } else {
          alert('복구에 실패했습니다.');
        }
      } catch (e) {
        console.error('Restore error:', e);
        alert('복구 중 오류가 발생했습니다.');
      }
    },
    async onEditDeptChange() {
      try {
        if (!this.editingStudent || !this.editingStudent.classid) {
          this.editGrades = [];
          return;
        }
        const res = await apiservice.getclasslist({ classid: this.editingStudent.classid });
        this.editGrades = (res.data && res.data.data)
          ? res.data.data.map(g => ({ grade: g.grade, gradename: g.gradename }))
          : [];
        // 현재 선택된 grade가 목록에 없으면 초기화
        if (!this.editGrades.find(g => g.grade === this.editingStudent.grade)) {
          this.editingStudent.grade = '';
          this.editingStudent.gradename = '';
          this.editingStudent.teacherid = '';
          this.editingStudent.teachername = '';
        } else {
          this.syncEditGradename();
        }
      } catch (e) {
        this.editGrades = [];
      }
    },
    syncEditGradename() {
      const found = this.editGrades.find(g => g.grade === this.editingStudent.grade);
      this.editingStudent.gradename = found ? found.gradename : '';
      // 반이 확정되면 해당 부서/반의 선생님 정보 동기화
      if (this.editingStudent.classid && this.editingStudent.grade) {
        this.fetchTeacherByClassGrade();
      } else {
        this.editingStudent.teacherid = '';
        this.editingStudent.teachername = '';
      }
    },
    async fetchTeacherByClassGrade() {
      try {
        const resp = await apiservice.get_teachers_by_class_grade({
          classid: this.editingStudent.classid,
          grade: this.editingStudent.grade
        });
        const rows = resp?.data?.data || [];
        if (rows.length > 0) {
          // 다수인 경우 첫 번째 값을 기본 적용
          this.editingStudent.teacherid = rows[0].teacherid || '';
          this.editingStudent.teachername = rows[0].teachername || '';
        } else {
          this.editingStudent.teacherid = '';
          this.editingStudent.teachername = '';
        }
      } catch (e) {
        this.editingStudent.teacherid = '';
        this.editingStudent.teachername = '';
      }
    },
    toggleIncludeDeleted(e) {
      const include = e?.target?.checked === true;
      this.filters.withdrawal = include ? 'include' : 'exclude';
      // include 시에는 useyn 필터를 비워 Y/N 모두 조회, exclude 시에는 활성만
      this.filters.useyn = include ? '' : 'Y';
      this.fetchStudents(1);
    },
  },
  async mounted() {
    try {
      await this.fetchDepartments();
      
      // 사용자 권한 확인 및 부서 고정 처리
      const userData = this.$store.state.userData;
      if (userData && userData.superuser !== '1') {
        // superuser가 1이 아닌 경우 classid 값으로 department.id 고정
        this.filters.department = userData.classid;
        // 부서 선택 후 반 목록 가져오기
        await this.fetchGrades();
        // 학생 목록 자동 조회
        this.fetchStudents(1);
      }
    } catch (error) {
      console.error("Error in mounted:", error);
    }
  },
};
</script>

<style scoped>
.pagination {
  margin-bottom: 0;
}

.page-link {
  color: #4CAF50;
}

.page-item.active .page-link {
  background-color: #4CAF50;
  border-color: #4CAF50;
}

.searchInput {
  text-align: center;
  background-color: white !important;
  margin-bottom: 0;
}

/* 입력 요소 스타일 */
.form-control, .form-select {
  border: 1px solid #ced4da !important;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: white !important;
}

.form-control:focus, .form-select:focus {
  border-color: #80bdff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* 상세 카드 내부 간격 1/2 축소 */
.detail-compact {
  /* 가로/세로 gutter 더 축소 */
  --bs-gutter-x: 0.5rem;  /* 더 작게 */
  --bs-gutter-y: 0.25rem; /* 더 작게 */
}
.detail-compact .row {
  margin-bottom: 0.25rem;
}
.detail-compact .row.mt-3 {
  margin-top: 0.5rem !important; /* 안전하게 */
}
.detail-compact h6 {
  margin-bottom: 0.125rem;
  font-size: 0.9rem;
}
.detail-compact p {
  margin-bottom: 0; /* 텍스트 아래 여백 제거 */
}
.detail-compact .form-control {
  padding: 6px 10px; /* 입력 여백 축소 */
}
.detail-compact .info-grid > [class*='col-'] {
  margin-bottom: 0.25rem; /* 각 항목 간 간격 최소화 */
}

/* 개행과 연속 공백 보존 */
.preline {
  white-space: pre-line;
}

/* 검색 입력 폭 조절 */
.search-name {
  width: 140px;
}

/* 상단 필터 바 반응형 정렬 */
.filters-bar {
  gap: 8px;
}
.filters-bar .form-select {
  min-width: 160px;
}

/* 하단 검색줄 정렬 */
.search-tools {
  gap: 8px;
}
.search-tools .btn {
  height: 32px;
  line-height: 1;
}
.search-tools .form-check-input {
  margin-top: 0;
}

/* 상세 사진 반응형 크기 */
.profile-photo {
  width: 100%;
  max-width: 240px;
  height: auto;
}
@media (max-width: 1200px) {
  .profile-photo { max-width: 220px; }
}
@media (max-width: 992px) {
  .profile-photo { max-width: 180px; }
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .form-select, .form-control {
    width: 100% !important;
    margin-bottom: 10px;
  }
  .searchInput {
    text-align: left;
  }
  .filters-bar .form-select {
    flex: 1 1 48%;
  }
  .search-tools .search-name {
    width: 100%;
    min-width: 180px;
  }
}
</style>
